import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  icon: {
    verticalAlign: 'sub'
  }
}));

function ErrorAlertIcon({ className }) {
  const classes = useStyles();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" className={clsx(classes.icon, className)}>
      <g id="alert-circle" transform="translate(-2 -2)">
        <circle id="Ellipse_1" dataName="Ellipse 1" cx="10" cy="10" r="10" transform="translate(2 2)" fill="rgba(255, 0, 70, 0.17)"/>
        <line id="Line_1" dataName="Line 1" y2="5" transform="translate(12 7.5)" fill="none" stroke="#e50146" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.75"/>
        <line id="Line_2" dataName="Line 2" x2="0.01" transform="translate(11.99 17)" fill="none" stroke="#e50146" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
      </g>
    </svg>
  );
}

ErrorAlertIcon.propTypes = {
  className: PropTypes.string
};

export default ErrorAlertIcon;
